import IconPicker from "../components/IconPicker";
import { BASIC_INNER_BLOCK } from '../constants';
import { __ } from "@wordpress/i18n";
import {
  RichText,
  InnerBlocks,
  useBlockProps
} from "@wordpress/block-editor";
import React, {FC} from "react";

interface EditProps {
  attributes: {
    headline?: string;
    icon?: string;
  };
  setAttributes: (attributes: Record<string, any>) => void;
  isSelected: boolean;
}

const Edit: FC<EditProps> = ({
  attributes: { headline, icon },
  setAttributes,
  isSelected,
}) => {
  return (
    <>
      <IconPicker
        attributes={{
          icon
        }}
        setAttributes={setAttributes}
      />
      <aside {...useBlockProps()}>
        <header className="card__header">
          <h3 className="card__title">
            <i className={icon}></i>
            <RichText
              value={headline}
              placeholder={__("Lorem ipsum…", "neodigital")}
              keepplaceholderonfocus="true"
              onChange={(headline) => setAttributes({ headline })}
            />
          </h3>
        </header>
        <div className="card__body">
          <InnerBlocks allowedBlocks={BASIC_INNER_BLOCK} />
        </div>
      </aside>
    </>
  );
};

export default Edit;
